<template>
  <div>
    <!-- <RenderCacheable v-if="footer" :cache-key="cacheKey" :max-age="600"> -->
    <PageFooter v-if="footer" v-bind="footer" />
    <!-- </RenderCacheable> -->
  </div>
</template>

<script lang="ts" setup>
const language = useCurrentLanguage()

const { data: footer } = await useAsyncGraphqlQuery('footerQuery', null, {
  transform: (v) => v.data.footer,
  graphqlCaching: {
    client: true,
  },
  watch: [language],
})
</script>
